// src/pages/produccion/ConfigMezclaReceta.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function ConfigMezclaReceta() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoReceta, setGuardandoReceta] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/produccion/config/kg-por-carro');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiar(receta, campo, valor) {
    setFilas((prev) => prev.map((f) => {
      if (f.receta !== receta) return f;
      const actualizada = { ...f, [campo]: valor };
      const kgMzReceta = parseFloat(actualizada.kg_mz_x_receta) || 0;
      const recetasCarro = parseFloat(actualizada.recetas_x_carro) || 0;
      const perdidaTotal =
        (parseFloat(actualizada.humedad_perdida) || 0) +
        (parseFloat(actualizada.merma_perdida) || 0) +
        (parseFloat(actualizada.rechazo_perdida) || 0);
      actualizada.kg_mz_x_carro = (kgMzReceta * recetasCarro).toFixed(3);
      actualizada.perdida_total = perdidaTotal.toFixed(4);
      actualizada.kg_pt_x_carro = (kgMzReceta * recetasCarro * (1 - perdidaTotal)).toFixed(3);
      return actualizada;
    }));
  }

  async function handleGuardar(receta) {
    const fila = filas.find((f) => f.receta === receta);
    try {
      setGuardandoReceta(receta);
      setMensaje(null);
      const res = await api.put(`/api/produccion/config/kg-por-carro/${encodeURIComponent(receta)}`, {
        kg_mz_x_receta: fila.kg_mz_x_receta,
        recetas_x_carro: fila.recetas_x_carro,
        humedad_perdida: fila.humedad_perdida,
        merma_perdida: fila.merma_perdida,
        rechazo_perdida: fila.rechazo_perdida,
      });
      setFilas((prev) => prev.map((f) => (f.receta === receta ? res.data.data : f)));
      setMensaje({ tipo: 'ok', texto: `✓ ${receta} actualizado.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: `No se pudo guardar ${receta}.` });
    } finally {
      setGuardandoReceta(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>Configuración de Mezcla por Receta (hoja "Mz")</h1>
      <p style={styles.subtitulo}>
        Los campos morados se editan; los grises se calculan solos — mismas fórmulas que el Excel:
        Kg Mz x Carro = Kg Mz x Receta × Recetas x Carro · Pérdida Total = suma de las 3 pérdidas ·
        Kg de PT x Carro = Kg Mz x Carro × (1 − Pérdida Total).
      </p>

      {mensaje && (
        <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>
          {mensaje.texto}
        </div>
      )}

      <div style={styles.tablaScroll}>
        <table style={styles.tabla}>
          <thead>
            <tr>
              <th style={styles.th}>Producto</th>
              <th style={{ ...styles.th, ...styles.thEditable }}>Kg Mz x Receta</th>
              <th style={{ ...styles.th, ...styles.thEditable }}>Recetas x Carro</th>
              <th style={styles.th}>Kg Mz x Carro</th>
              <th style={{ ...styles.th, ...styles.thEditable }}>Humedad Perdida</th>
              <th style={{ ...styles.th, ...styles.thEditable }}>Merma Perdida</th>
              <th style={{ ...styles.th, ...styles.thEditable }}>Rechazo Perdida</th>
              <th style={styles.th}>Pérdida Total</th>
              <th style={styles.th}>Kg de PT x Carro</th>
              <th style={styles.th}></th>
            </tr>
          </thead>
          <tbody>
            {filas.map((f) => (
              <tr key={f.receta}>
                <td style={{ ...styles.td, fontWeight: 600, color: '#2A1830' }}>{f.receta}</td>
                <CeldaEditable valor={f.kg_mz_x_receta} onChange={(v) => handleCambiar(f.receta, 'kg_mz_x_receta', v)} paso="0.001" />
                <CeldaEditable valor={f.recetas_x_carro} onChange={(v) => handleCambiar(f.receta, 'recetas_x_carro', v)} paso="1" />
                <CeldaCalculada valor={f.kg_mz_x_carro} />
                <CeldaEditable valor={f.humedad_perdida} onChange={(v) => handleCambiar(f.receta, 'humedad_perdida', v)} paso="0.001" />
                <CeldaEditable valor={f.merma_perdida} onChange={(v) => handleCambiar(f.receta, 'merma_perdida', v)} paso="0.001" />
                <CeldaEditable valor={f.rechazo_perdida} onChange={(v) => handleCambiar(f.receta, 'rechazo_perdida', v)} paso="0.001" />
                <CeldaCalculada valor={f.perdida_total} />
                <CeldaCalculada valor={f.kg_pt_x_carro} resaltada />
                <td style={styles.td}>
                  <button
                    onClick={() => handleGuardar(f.receta)}
                    disabled={guardandoReceta === f.receta}
                    style={styles.botonGuardar}
                  >
                    {guardandoReceta === f.receta ? '...' : 'Guardar'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function CeldaEditable({ valor, onChange, paso }) {
  return (
    <td style={styles.td}>
      <input type="number" step={paso} value={valor} onChange={(e) => onChange(e.target.value)} style={styles.inputEditable} />
    </td>
  );
}

function CeldaCalculada({ valor, resaltada }) {
  return (
    <td style={{ ...styles.td, ...styles.celdaCalculada, ...(resaltada ? styles.celdaResaltada : {}) }}>
      {valor}
    </td>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '1100px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px', fontSize: '22px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '16px', lineHeight: 1.6 },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tablaScroll: { overflowX: 'auto', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' },
  th: { textAlign: 'left', padding: '10px 8px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '10px', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  thEditable: { color: '#8A2BE2', background: '#F7EDD6' },
  td: { padding: '6px 8px', borderBottom: '1px solid #F0E9E0', whiteSpace: 'nowrap' },
  inputEditable: { width: '75px', padding: '5px 6px', fontSize: '12px', border: '1px solid #D6A644', borderRadius: '5px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  celdaCalculada: { color: '#8A7690', fontStyle: 'italic' },
  celdaResaltada: { color: '#3E7C5A', fontWeight: 700, fontStyle: 'normal' },
  botonGuardar: { padding: '5px 10px', fontSize: '11px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};